<template>
  <div class="versionDialog">
    <el-dialog
      :visible.sync="isOpen"
      :width="dialogWidth"
      :show-close="showCloseBtn"
      class="egl-dialog-elm"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-header" v-if="!!titleText">
        {{ titleText }}
        <el-tooltip effect="dark" :content="titleText" placement="top">
          <img src="../../assets/img/tips.png" alt="Tips" />
        </el-tooltip>
      </div>
      <slot></slot>
      <div slot="footer" class="dialog-footer">
        <el-row :gutter="20">
          <el-col :span="24" v-if="!oneButton">
            <el-button @click="closeAction()" class="egl-btn-white">{{
              $locale("global.cancel")
            }}</el-button>
            <el-button
              type="primary"
              @click="confirmAction()"
              class="egl-btn-yellow"
            >
              {{ btnText ? btnText : $locale("global.confirm") }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/style/dialog.less";

export default {
  computed: {
    isOpen: {
      get() {
        return this.visible;
      },
      set() {
        this.closeAction();
      }
    }
  },
  props: {
    visible: {
      type: Boolean
    },
    content: {
      type: String,
      default: ""
    },
    type: {
      type: String // 'edit | delete'
    },
    btnText: {
      type: String
    },
    titleText: {
      type: String
    },
    dialogWidth: {
      type: String,
      default: () => "70%"
    },
    showCloseBtn: {
      type: Boolean,
      default: true
    },
    closeAction: {
      type: Function,
      default: () => {}
    },
    confirmAction: {
      type: Function,
      default: () => {}
    },
    oneButton: {
      type: Boolean,
      default: false
    }
  }
};
</script>
